import { defineMessages } from 'react-intl';

export default defineMessages({
    genericHeading: {
        defaultMessage: 'Something bad happened',
        description: 'Generic error when something could not be loaded',
        id: 'cv.advanced-help-center.view-homepage.error-page.generic.error.heading.non-final',
    },
    genericMessage: {
        defaultMessage: 'Looks like we’re having trouble retrieving some information, please refresh the page.',
        description: 'Generic error when something could not be loaded',
        id: 'cv.advanced-help-center.view-home-page.error-page.generic.error.message.non-final',
    },
    helpCenterTitle: {
        defaultMessage: '{helpCenterTitle} - Jira Service Management',
        description: 'Page title for help center landing page',
        id: 'cv.advanced-help-center.view-home-pager.page.title',
    },
});
